'use client';

import { FC, ForwardedRef, forwardRef, useRef } from 'react';

import { JoinButton } from './JoinButton';
import { useIsVisible } from 'hooks/useIsVisible';

interface ICallToAction {
  title: string;
  buttonText: string;
  isPreview?: boolean;
}

export const CallToAction = forwardRef((props: ICallToAction, ref: ForwardedRef<HTMLDivElement>) => {
  const { title, buttonText, isPreview } = props;

  const ctaRef = useRef<HTMLDivElement>(null);
  const isVisibleCTA = useIsVisible(ctaRef);

  return (
    <div ref={ref}>
      <div
        ref={ctaRef}
        className={`flex items-center justify-center p-10 gap-3.5 md:p-5 md:pb-9 duration-1000 transition-all ${isVisibleCTA ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}>
        <div className="container">
          <div className="py-9 px-5 flex flex-col gap-9 justify-between font-poppins md:p-0">
            <div
              className="flex flex-col justify-center items-center w-full rounded-2xl bg-purple-blue py-12 sm: p-6 relative after:absolute after:top-full after:content-[''] after:w-10/12 after:h-7 after:rounded-b-md after:bg-purple-blue after:left-2/4 after:-translate-x-1/2 after:opacity-30">
              <div className="flex flex-col justify-center items-center w-3/5 gap-9 sm:w-full">
                <h2
                  className="font-poppins text-4xl text-white font-semibold text-center sm:text-3xl">{title}</h2>
                <div className="flex">
                  <JoinButton title={buttonText} location="cta" isPreview={isPreview} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

CallToAction.displayName = 'CallToAction';
